import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useEffect, useState } from 'react';
import { MdAttachMoney, MdBadge, MdCalendarToday, MdDownload, MdFormatListNumbered, MdPerson, MdReceipt, MdRequestQuote, MdTrendingUp } from 'react-icons/md';
import { useHistory, useLocation } from 'react-router-dom';
import { ModalLoader } from '../../../../Components/Atoms/ModalLoader';
import { ScreenGreeting } from '../../../../Components/Molecules';
import { AnticipationModal } from '../../../../Components/Molecules/Anticipation/AnticipationModal';
import { InvoiceCard } from '../../../../Components/Molecules/Anticipation/InvoiceCard';
import { InvoiceDuplicateList } from '../../../../Components/Molecules/Anticipation/InvoiceDuplicateList';
import { useInvoiceDuplicate } from '../../../../Hooks/Anticipation';
import { useToast } from '../../../../Hooks/toast';
import useCallAxios from '../../../../Hooks/useCallAxios';
import { formatDocument } from '../../../../Utils/formatters';
import api from '../../../../Services/api';

export const InvoiceDuplicates = () => {
    const [duplicates, setduplicates] = useState({} as any);
    const [selectedDuplicates, setSelectedDuplicates] = useState<any[]>([]);
    const [openTermsModal, setOpenTermsModal] = useState(false);
    const history = useHistory();
    const { addToast } = useToast();
    const { state } = useLocation<{ invoiceIds?: string[] }>();
    const invoiceIds = state?.invoiceIds || [];

    const [requestCount, setRequestCount] = useState(0);

    const contextStatus = "invoiceStatus";
    const context = "invoiceDuplicates";

    const {
        fetchGET: fetchDuplicates,
        requestLoading: loading,
        requestData,
        requestError: error,
    } = useCallAxios({ context });

    const {
        fetchGET: fetchStatus,
        requestError: errorStatus,
    } = useCallAxios({ context: contextStatus });

    useEffect(() => {
        fetchStatus({ showToast: false });
    }, [contextStatus]);

    useEffect(() => {
        if (errorStatus.GET != null && errorStatus.GET)
            history.push({
                pathname: "/anticipation",
            });
    }, [errorStatus.GET]);

    const {
        success: requestSuccessPost,
        loading: loadingPost,
        handlePOST: fetchAnticipation,
        error: errorPost
    } = useInvoiceDuplicate();

    useEffect(() => {
        invoiceIds.forEach(id => {
            fetchDuplicates({ id });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoiceIds]);

    useEffect(() => {
        if (error?.GET || errorPost) {
            history.push({
                pathname: "/anticipation",
            });
        }
    }, [error.GET, errorPost]);


    const handleDownloadBoletos = async () => {
        try {
            setRequestCount(rc => rc + 1);
            const antecipationId = duplicates.nfs.anticipationId;

            const response = await api.get(`Boleto/print/anticipation/bulk/${antecipationId}`, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/zip' });
            const downloadUrl = URL.createObjectURL(blob);

            const $a = document.createElement("a");
            $a.href = downloadUrl;
            $a.download = "comprovantes-antecipacao.zip";

            document.body.appendChild($a);
            $a.click();

            $a.remove();
            URL.revokeObjectURL(downloadUrl);
        }
        finally {
            setRequestCount(rc => rc - 1);
        }
    }

    useEffect(() => {
        const data = (requestData as any)?.data;
        if (!data) return;

        setduplicates((prev) => {
            const isFirstLoad = Object.keys(prev).length === 0;
            const currentStatusId = prev?.nfs?.status?.id ?? data?.nfs?.status?.id;

            const newDup = isFirstLoad
                ? data.dup || []
                : [...(prev.dup || []), ...(data.dup || [])];

            const totalAmount = newDup.reduce((sum, item) => {
                const amount = Number(item?.receivableAmount || 0);
                return sum + amount;
            }, 0);

            if (currentStatusId !== 1) {
                setSelectedDuplicates(newDup.filter((d: any) => d.anticipatedAmount !== 0));
            } else {
                setSelectedDuplicates(newDup);
            }

            return isFirstLoad
                ? {
                    ...data,
                    totalAmount,
                }
                : {
                    ...prev,
                    dup: newDup,
                    totalAmount,
                };
        });
    }, [requestData]);

    useEffect(() => {
        if (!requestSuccessPost) return;
        addToast({
            type: "info",
            title: "Solicitação finalizada!",
            description: "Sua solicitação finalizada e poderá ser acompanhada através da plataforma.",
        });

        history.push({
            pathname: "/anticipation",
            state: {
                message: "Solicitação realizada com sucesso!",
                type: "success",
            },
        });
    }, [requestSuccessPost]);

    const handleContinue = () => {
        setOpenTermsModal(true);
    }

    const handleCancel = async () => {
        setRequestCount(rc => rc + 1);

        try {
            const antecipationId = duplicates.nfs.anticipationId;
            await api.delete(`v2/anticipation/invoice/${antecipationId}`);

            addToast({
                type: "success",
                title: "sucesso",
                description: "Cancelamento enviado com sucesso.",
            });

            return history.push('/antecipation');
        }
        finally {
            setRequestCount(rc => rc - 1);
        }
    }

    const handleAcceptTerms = () => {
        const grouped = selectedDuplicates.reduce((acc: Record<string, any[]>, dup: any) => {
            const key = dup.anticipationId;
            if (!acc[key]) acc[key] = [];
            acc[key].push(dup);
            return acc;
        }, {});

        Object.entries(grouped).forEach(([anticipationId, dups]) => {
            fetchAnticipation({
                anticipationId: anticipationId,
                duplicateIds: (dups as any[]).map((d: any) => d.anticipationDuplicateId)
            });
        });
        setOpenTermsModal(false);
    };

    const totals = selectedDuplicates.reduce(
        (acc, curr) => {
            acc.count += 1;
            acc.amount += curr.amount || 0;
            acc.rate += curr.rate || 0;
            acc.netAmount += curr.netAmount || 0;
            acc.receivableAmount += curr.receivableAmount || 0;
            return acc;
        },
        {
            count: 0,
            amount: 0,
            rate: 0,
            netAmount: 0,
            receivableAmount: 0,
        }
    );

    const getStatusColor = (status: string | undefined) => {
        switch (status) {
            case "Enviada":
                return { background: "#E0F7FA", color: "#00796B" };
            case "Rejeitada":
                return { background: "#FFEBEE", color: "#C62828" };
            case "Inválida":
                return { background: "#FFF3E0", color: "#EF6C00" };
            case "Aprovada":
                return { background: "#E8F5E9", color: "#2E7D32" };
            case "Antecipada":
                return { background: "#E3F2FD", color: "#1565C0" };
            case "Validada":
                return { background: "#F3E5F5", color: "#6A1B9A" };
            case "Aguardando Validação":
                return { background: "#EEEEEE", color: "#5B5B5B" };
            default:
                return { background: "#E0E0E0", color: "#424242" };
        }
    };

    const InfoBox = ({ icon: Icon, label, value, boxShadow = true }: any) => (
        <Paper
            variant="outlined"
            elevation={3}
            sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                boxShadow: boxShadow ? 2 : 0,
            }}
        >
            {Icon && <Icon size={28} color="#616161" />}
            <Box>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="subtitle1">
                    {loading.GET || !value ? '...' : value}
                </Typography>
            </Box>
        </Paper>
    );

    const InfoBoxAnticipation = ({ label, value }: any) => (
        <Paper
            variant="outlined"
            sx={{
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: "space-between",
                gap: 2
            }}
        >
            <Typography variant="body2" fontWeight={600} color="text.secondary">
                {label}
            </Typography>
            <Typography fontWeight={400} variant="subtitle1">
                {value}
            </Typography>
        </Paper>
    );

    return (
        <>
            <ModalLoader
                open={loading.GET || loadingPost || requestCount > 0}
                text={"Carregando informações"}
            />
            <ScreenGreeting
                title={"Duplicatas"}
                subTitle={
                    "Aqui você poderá visualizar as duplicatas."
                }
                hasBackButton
                handleBack={() => history.push({ pathname: "/anticipation" })}
            />

            <Grid2 spacing={2} container sx={{ mb: 2 }}>
                <Grid2 xs={12} lg={4} md={6}>
                    <InvoiceCard
                        title="Total Antecipável"
                        loading={false}
                        icon={MdAttachMoney}
                        value={
                            (duplicates?.totalAmount || 0).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })
                        }
                    />
                </Grid2>
                <Grid2 xs={12} lg={4} md={6}>
                    <InvoiceCard
                        title="Limite de Antecipação"
                        loading={false}
                        icon={MdTrendingUp}
                        value={
                            (duplicates?.totals?.limit || 0).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })
                        }
                    />
                </Grid2>
                <Grid2 xs={12} lg={4} md={6}>
                    <InvoiceCard
                        title="Valor Liberado por Nota"
                        loading={false}
                        icon={MdRequestQuote}
                        value={((duplicates?.totals?.limit_per_nf || 0) / 100).toLocaleString('pt-BR', {
                            style: 'percent',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    />
                </Grid2>
            </Grid2>
            {invoiceIds.length === 1 && (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                        <Typography
                            sx={{
                                background: duplicates?.nfs?.manifested ? '#E0F7FA' : '#FFEBEE',
                                color: duplicates?.nfs?.manifested ? '#00796B' : '#C62828',
                                px: 2,
                                py: 0.5,
                                borderRadius: '16px',
                                fontWeight: 500,
                                fontSize: '0.875rem',
                                display: 'inline-block'
                            }}
                        >
                            {duplicates?.nfs?.manifested ? 'Manifestada' : 'Não Manifestada'}
                        </Typography>
                        <Typography
                            sx={{
                                background: getStatusColor(duplicates?.nfs?.status?.name).background,
                                color: getStatusColor(duplicates?.nfs?.status?.name).color,
                                px: 2,
                                py: 0.5,
                                borderRadius: '16px',
                                fontWeight: 500,
                                fontSize: '0.875rem',
                                display: 'inline-block'
                            }}
                        >
                            {duplicates?.nfs?.status?.name}
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <InfoBox
                                icon={MdCalendarToday}
                                label="Data de Emissão"
                                value={duplicates?.nfs?.issueDate ? new Date(duplicates?.nfs?.issueDate).toLocaleDateString("pt-BR") : "N/A"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InfoBox
                                icon={MdReceipt}
                                label="Protocolo"
                                value={duplicates?.nfs?.protocol || "N/A"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InfoBox
                                icon={MdAttachMoney}
                                label="Valor Total"
                                value={(duplicates?.nfs?.amount || 0).toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InfoBox
                                icon={MdFormatListNumbered}
                                label="Duplicatas"
                                value={Array.isArray(duplicates?.dup) ? duplicates.dup.length : 0}
                            />
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <InfoBox
                                icon={MdPerson}
                                label="Comprador"
                                value={duplicates?.nfs?.customer?.tradeName || "N/A"}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InfoBox
                                icon={MdBadge}
                                label="Documento"
                                value={formatDocument(
                                    duplicates?.nfs?.customer?.nationalRegistration,
                                    duplicates?.nfs?.customer?.nationalRegistration && duplicates?.nfs?.customer?.nationalRegistration.length > 11
                                        ? "CNPJ_COMPACT"
                                        : "CPF"
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant='contained' onClick={handleDownloadBoletos}>
                                <MdDownload fontSize={'24px'}/>
                                <span style={{ marginLeft: '5px' }}>Download dos boletos</span>                              
                            </Button>
                        </Grid>
                    </Grid>
                </>
            )}

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} md={8} sx={{ pointerEvents: duplicates?.nfs?.status?.id !== 1 ? 'none' : 'auto', opacity: duplicates?.nfs?.status?.id !== 1 ? 0.5 : 1 }}>
                    <InvoiceDuplicateList
                        duplicates={duplicates?.dup || []}
                        limitPerInvoice={duplicates?.totals?.limit_per_nf}
                        selected={selectedDuplicates}
                        setSelected={setSelectedDuplicates} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Typography variant="h5" fontWeight={600}>Cesta de antecipação</Typography>
                        </Box>
                        <Grid container sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                                <InfoBoxAnticipation
                                    label="Total de Duplicatas"
                                    value={totals.count}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InfoBoxAnticipation
                                    label="Valor Bruto"
                                    value={(totals.amount).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InfoBoxAnticipation
                                    label="Taxa"
                                    value={(totals.rate).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InfoBoxAnticipation
                                    label="Valor Líquido"
                                    value={(totals.netAmount).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InfoBoxAnticipation
                                    label="Valor à Receber"
                                    value={(totals.receivableAmount).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                />
                            </Grid>
                        </Grid>
                        {
                            (duplicates?.nfs?.status?.id===1) &&
                            <div>
                                <Box sx={{ mt: 3 }}>
                                    <Typography variant="h6" fontWeight={600}>
                                        Revisar e continuar para antecipação
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
                                        Juros, descontos mostrados estão sujeitos a alterações sem aviso prévio.
                                    </Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{ mt: 2, color: 'white' }}
                                    onClick={handleContinue}
                                    disabled={selectedDuplicates.length === 0 || duplicates?.nfs?.status?.id !== 1}
                                >
                                    Continuar para Antecipação
                                </Button>
                            </div>
                        }
                        {
                            [1,7].includes(duplicates?.nfs?.status?.id) &&
                                <Button
                                    variant="contained"
                                    fullWidth
                                    color='error'
                                    sx={{ mt: 2, color: 'white' }}
                                    onClick={handleCancel}
                                >
                                    Cancelar Envio
                                </Button>
                        }
                        <AnticipationModal
                            open={openTermsModal}
                            onClose={() => setOpenTermsModal(false)}
                            onContinue={handleAcceptTerms}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};